import LooaderGif from "assets/images/gifs/learnlocalLoader.gif";

const Loader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 z-50">
      <img src={LooaderGif} alt="Loading..." className="w-20 h-20" />
    </div>
  );
};

export default Loader;
